import React, { useEffect, useRef, useState } from "react";
import { FaBriefcase, FaGraduationCap, FaMapMarkerAlt } from "react-icons/fa";
import { experiences } from "../../data/portfolioData";
import { useLanguage } from "../../context/LanguageContext";
import "./Experience.css";

const Experience = ({
  id = "experience",
  title = "Experience",
  subtitle = "Where I've worked",
  items = experiences.filter((e) => e.type === "work"),
}) => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);
  const { t } = useLanguage();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="experience" id={id} ref={sectionRef}>
      <div className="experience__container">
        <h2 className="section-title">{title}</h2>
        <p className="section-subtitle">{subtitle}</p>

        <div className="timeline">
          {items.map((exp, idx) => (
            (() => {
              const translated = t.experienceItems?.[exp.id] || {};
              return (
            <div
              key={exp.id}
              className={`timeline__item ${
                idx % 2 === 0 ? "timeline__item--left" : "timeline__item--right"
              } ${visible ? "animate-fade-up" : ""}`}
              style={{ animationDelay: `${idx * 0.15}s` }}
            >
              <div className="timeline__icon">
                {exp.type === "work" ? <FaBriefcase /> : <FaGraduationCap />}
              </div>
              <div className="timeline__card">
                <span className="timeline__date">
                  {translated.startDate || exp.startDate} — {translated.endDate || exp.endDate}
                </span>
                <h3 className="timeline__title">{translated.title || exp.title}</h3>
                <h4 className="timeline__org">{translated.organization || exp.organization}</h4>
                <p className="timeline__location">
                  <FaMapMarkerAlt /> {exp.location}
                </p>
                <p className="timeline__desc">{translated.description || exp.description}</p>
                <div className="timeline__tech">
                  {exp.technologies.map((tech) => (
                    <span key={tech} className="tech-tag">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
              );
            })()
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
